import { v4 as uuidv4 } from 'uuid';
import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import { ITask, ITasksResult, ITasksState, ITasksToShow } from './types';
import initialTasksState from './initialState';
import Helpers from 'utils/Helpers';
import newTaskObj from 'constants/newTask';
import { generateUniqueId } from 'utils/hooks/generateUniqueId';

const tasksSlice = createSlice({
  name: 'tasks',
  initialState: initialTasksState(),
  reducers: {
    set_tasks(state: ITasksState, action: PayloadAction<ITasksResult[]>) {
      state.tasks = action.payload;
      state.loading = false;
    },
    set_tasks_to_show(state: ITasksState, action: PayloadAction<ITasksToShow>) {
      state.tasksToShow = action.payload;
      state.loading = false;
    },
    add_new_task(state: ITasksState, action: PayloadAction<number>) {
      const oldState = current(state);

      const regReqObj = oldState.tasks.find(
        (item) => item.sol_id === action.payload
      );

      if (!regReqObj) return;

      const newTaskData = newTaskObj(regReqObj.sol_id);
      const taskId = `new-${newTaskData.tsk_id}`;

      const newTask = {
        ...regReqObj,
        task_id: taskId,
        TASKS: newTaskData
      };

      const rows = [...oldState.tasksToShow];

      const lastIndex = rows.reduce(
        (last, row, index) => (row.sol_id === action.payload ? index : last),
        -1
      );

      rows.splice(lastIndex + 1, 0, newTask);

      state.tasksToShow = rows;
      state.tasksToSave = {
        ...oldState.tasksToSave,
        [taskId]: newTaskData
      };
      state.loading = false;
    },
    edit_task(
      state: ITasksState,
      action: PayloadAction<{
        tskId: string | number;
        taskData: ITask;
        key: string;
        value: string;
      }>
    ) {
      const oldState = current(state);
      const { tskId, taskData, key, value } = action.payload;
      const { ...rest } = taskData;
      const taskToSave =
        oldState.tasksToSave[tskId] &&
        !Helpers.isObjEmpty(oldState.tasksToSave[tskId])
          ? { ...oldState.tasksToSave[tskId] }
          : { ...rest, tsk_id: rest.tsk_id, tsk_sol_ref: rest.tsk_sol_ref };

      state.tasksToSave = {
        ...oldState.tasksToSave,
        [tskId]: {
          ...taskToSave,
          [key]: value
        }
      };
      state.loading = false;
    },
    reset_tasks_to_save(state: ITasksState) {
      state.tasksToSave = {};
    },
    delete_task: (
      state,
      action: PayloadAction<{ taskId: string | number; solId: number }>
    ) => {
      const oldState = current(state);

      const { taskId } = action.payload;

      state.tasksToShow = oldState.tasksToShow.filter(
        (task) => task.task_id !== taskId
      );

      if (oldState.tasksToSave[taskId]) {
        const { [taskId]: _, ...rest } = oldState.tasksToSave;
        state.tasksToSave = rest;
      }

      state.error = false;
      state.loading = false;
    },
    set_loading(state: ITasksState, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    set_error(state: ITasksState, action: PayloadAction<any>) {
      state.error = action.payload;
      state.loading = false;
    }
  }
});

export default tasksSlice;
